import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { themeColors } from '../../../styles/themeColors';

export default makeStyles((theme: Theme) => ({
  container: {
    overflow: 'hidden',
    position: 'absolute',
    width: 340,
    height: 470,
    transformOrigin: 'top',
    boxShadow: '0px 6px 6px 1px rgba(0,0,0,0.2)',
  },

  headerCell: {
    position: 'relative',
    display: 'table-cell',
    verticalAlign: 'middle',

    zIndex: 10,
    lineHeight: 1,
    fontWeight: 600,
    padding: 0,
    cursor: 'pointer',
    borderBottom: `1px solid ${themeColors.headerRow}`,
  },

  cellContent: {
    display: 'flex',
    alignItems: 'center',
    padding: 16,
    // height: '100%'
  },

  filterContainer: {
    width: 340,
    height: 470,
    // top: 30,
    backgroundColor: 'white',
    border: `1px solid ${themeColors.borders}`,
    boxSizing: 'border-box',
    padding: 7,
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    // transition: '0.25s ease',
    top: '100%',
    left: 0,
    zIndex: 20,
    boxShadow: '0px 6px 8px 2px rgb(0 0 0 / 8%)',
  },

  allItemsSelectable: {
    // pointerEvents:'none',
    height: 46,
    borderBottom: `1px solid ${themeColors.borders}`,
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    paddingLeft: 15,
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },

  search: {
    height: 46,
    borderBottom: `1px solid ${themeColors.borders}`,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 15,
  },

  searchInput: {
    backgroundColor: 'transparent',
    background: 'unset',
    flexGrow: 1,
    marginRight: 10,

    '& div': {
      '&.MuiInput-underline:hover::before': {
        borderBottom: 'none',
      },
      '&:hover': {
        borderBottom: 'none',
      },

      '&::before': {
        borderBottom: 'none',
        '&:hover': {
          borderBottom: 'none',
        },
      },
      '&::after': {
        borderBottom: 'none',
        '&:hover': {
          borderBottom: 'none',
        },
      },
    },
    '& input': {
      fontSize: '1rem !important',
      fontWeight: 550,
    },
    '& .MuiInputBase-input': {
      background: 'white !important',
      backgroundColor: 'transparent',
    },
  },

  body: {
    flexGrow: 1,
    alignSelf: 'stretch',
    maxHeight: 288,
    overflowY: 'auto',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },

  item: {
    justifySelf: 'flex-start',
    alignSelf: 'self-start',

    '&.MuiFormControlLabel-root': {
      marginLeft: 7,
    },
    '& .MuiButtonBase-root': {
      padding: 5,
    },
  },

  infiniteScroll: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 238,
  },

  elementCheckbox: {
    padding: 3,
    display: 'block',
  },

  footer: {
    justifySelf: 'flex-end',
    height: 70,
    borderTop: `1px solid ${themeColors.borders}`,
    display: 'flex',
    justifyItems: 'stretch',
    boxSizing: 'border-box',
    paddingTop: 12.5,
  },

  footerIcon: {
    margin: '10px 20px 10px 15px',
    cursor: 'pointer',
  },

  footerButton: {
    height: 50,
    flexGrow: 1,
  },

  loading: {
    width: '100%',
    marginTop: '100px',
    display: 'flex',
    justifyContent: 'center',
  },

  noFound: {
    textAlign: 'center',
    fontStyle: 'italic',
    marginTop: 100,
  },

  dateInputContainer: {
    borderBottom: `1px solid ${themeColors.borders}`,
    paddingBottom: 11,
  },

  dateInput: {
    '& .MuiOutlinedInput-input': {
      padding: '9.5px 14px',
    },
    '& .MuiFormControl-marginNormal': { margin: 0 },
  },

  dateInputLabel: {
    opacity: '8px',
  },

  removeFilterIcon: {
    pointerEvents: 'all',
    fontSize: '1rem',
    marginRight: 5,
    zIndex: 120,
    '& path': {
      pointerEvents: 'none',
    },
  },

  withoutEvents: {
    userSelect: 'none',
    pointerEvents: 'none',
  },
}));
